import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import Classes from "./Notes.module.css";

export default function MessageItem({ name, role, time, message, index }) {
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        if (textRef.current) {
            setIsOverflowing(textRef.current.scrollHeight > 40);
        }
    }, [message]);

    return (
        <div className={Classes.message} style={{ paddingTop: index === 0 ? '0' : '' }} >
            <div className={Classes.messageHeader}>
                <strong>{name}</strong>
                <span className={Classes.dot} aria-hidden="true" />
                <span className={Classes.time}>{time}</span>
            </div>

            <motion.p
                ref={textRef}
                initial={{ height: "40px", overflow: "hidden" }}
                animate={{ height: expanded ? "auto" : "40px" }}
                transition={{ duration: 0.3 }}
                className={Classes.messageText}
            >
                {message}
            </motion.p>

            {isOverflowing && (
                <>
                    <div className={Classes.flexEnd} >
                        <button className={Classes.toggleButton} onClick={() => setExpanded(!expanded)}>
                            {expanded ? "See Less" : "See More"}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
